import { type CSSProperties } from 'react'
import { type Theme } from '@mui/material/styles'

import { type SeverityType } from '@Types/severity'

export const getColorBySeverity = (
  theme: Theme,
  severity: SeverityType,
  hasWhiteBackground = false,
): CSSProperties['color'] => {
  switch (severity) {
    case 'alert':
    case 'train_delete':
    case 'warning_red':
      return hasWhiteBackground ? theme.customPalette.onElements.elevated : theme.palette.error.main
    case 'delay':
    case 'roadworks':
    case 'warning':
      return theme.palette.warning.main
    case 'positive':
      return theme.palette.success.main
    case 'service':
      return theme.customPalette.alternative.alternativeColor1
    case 'info':
    case 'info_action':
    case 'info_message':
    default:
      return theme.customPalette.system.info
  }
}

export const getBackgroundColorBySeverity = (theme: Theme, severity?: SeverityType): CSSProperties['color'] => {
  switch (severity) {
    case 'alert':
    case 'train_delete':
    case 'warning_red':
      return theme.customPalette.system.dangerBackground
    case 'delay':
    case 'roadworks':
    case 'warning':
      return theme.customPalette.system.warningBackground
    case 'positive':
      return theme.customPalette.system.successBackground
    case 'info':
    case 'info_action':
    case 'info_message':
      return theme.customPalette.system.infoBackground
    default:
      return theme.customPalette.system.neutralBackground
  }
}
